'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSSTransitionGroup = _react2.default.addons.CSSTransitionGroup;


var DIRECTIONS = (0, _reactUtils.keyMirror)({
  top: null,
  bottom: null
});

exports.default = _react2.default.createClass({
  displayName: 'FadeSlideTransition',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    direction: _react.PropTypes.oneOf(Object.keys(DIRECTIONS)).isRequired,
    appear: _react.PropTypes.bool,
    enter: _react.PropTypes.bool,
    leave: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      direction: DIRECTIONS.top,
      appear: false,
      enter: true,
      leave: true
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        direction = _props.direction,
        appear = _props.appear,
        enter = _props.enter,
        leave = _props.leave;


    return _react2.default.createElement(
      CSSTransitionGroup,
      {
        className: (0, _reactUtils.classNames)('fade-slide-transition-container', className),
        transitionName: 'fade-slide-transition-' + direction,
        transitionAppear: appear,
        transitionEnter: enter,
        transitionLeave: leave,
        transitionAppearTimeout: 200,
        transitionEnterTimeout: 200,
        transitionLeaveTimeout: 200
      },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/components/transition/FadeSlideTransition.js
// module id = 152
// module chunks = 0 1